//import EdanData from 'model/Edan'
import WebRepository from '../web/WebRepository'
import Api from 'clients/web/Api'

export class EdanDataRepository extends WebRepository<any> {
  constructor() {
    super(new Api('edans'))
  }

  async search(): Promise<any[]> {
    return super.search({
      selector: {},
    })
  }
}

export default new EdanDataRepository()
